import React from 'react';
import { Helmet } from 'react-helmet';
import { getSiteOrigin } from '../config/site';

const DEFAULT_DESCRIPTION =
    'GOUNOD – професионални фитили и ленти за вдигане. Фитили RP Versa Grips style и Girlfriend version. Безплатна доставка при 2 или повече артикула.';

/**
 * Per-route SEO: title, description, canonical, Open Graph, Twitter, robots.
 * @param {string} title – page title (brand appended if missing)
 * @param {string} [description]
 * @param {string} [path] – pathname including leading slash
 * @param {boolean} [noindex]
 * @param {object|null} [jsonLd] – single JSON-LD object for structured data
 */
function SeoHead({
    title,
    description = DEFAULT_DESCRIPTION,
    path = '/',
    noindex = false,
    jsonLd = null,
    shareImage = null
}) {
    const origin = getSiteOrigin();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const url = `${origin}${normalizedPath === '//' ? '/' : normalizedPath}`;
    const brandSuffix = ' | GOUNOD';
    const fullTitle = title.toLowerCase().includes('gounod') ? title : `${title}${brandSuffix}`;
    const ogImage = shareImage || `${origin}/logo-gounod.png`;

    return (
        <Helmet htmlAttributes={{ lang: 'bg' }}>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta
                name="robots"
                content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'}
            />
            <meta name="googlebot" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="GOUNOD" />
            <meta property="og:locale" content="bg_BG" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />

            {!noindex && ogImage ? (
                <>
                    <meta property="og:image" content={ogImage} />
                    <meta property="og:image:alt" content="GOUNOD" />
                    <meta name="twitter:image" content={ogImage} />
                </>
            ) : null}

            {jsonLd ? (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            ) : null}
        </Helmet>
    );
}

export default SeoHead;
